import request from "../utils/request.js";
import axios from 'axios';
export const getAvatarSignedUrl = (userId) => {
  return request(`/users/signed-url/${userId}`, {
    method: 'GET',
  });
};

export const uploadToS3 = async (signedUrl, file, onUploadProgress, cancelToken) => {
  return axios.put(signedUrl, file, {
    cancelToken,
    onUploadProgress,
    headers: {
      'Content-Type': file.type,
    },
  });
};

export const getUserAvatar = async(userId) =>{
  return request({
    url: `/users/getAvatar/${userId}`,
    method: 'GET',
  });
}